import { useState, useEffect } from 'react';
import axiosInstance from '../axiosConfig';

export function useBankDetails() {
    const [bankDetails, setBankDetails] = useState([]);

    useEffect(() => {
        axiosInstance.get('/api/bank-details')
            .then(response => setBankDetails(response.data))
            .catch(error => console.error('Error fetching bank details:', error));
    }, []);

    return bankDetails;
}
